import { Injectable, signal } from '@angular/core';

/**
 * EPS-4465: lets a header declare that it pins itself to the top of the
 * viewport for a reason `headerData.isNavSticky` does not capture.
 *
 * The countdown topBanner (`banner.component.ts`) has to know, so it can pin
 * above that header rather than scroll up behind it, but it is a *sibling* of
 * the header — both render into the single-template `#head` outlet — so it
 * cannot inject anything the header provides. DEC is the case that needs this:
 * its simplified nav is unconditionally `position: sticky` in its own CSS
 * (CRO-1093 / EPS-4220) while every DEC page ships `isNavSticky: false`.
 *
 * Brands that pin through the global `.sticky-header` class need not report —
 * the banner still reads the Craft flag for those. Defaults to `false` so a
 * page with no such header, or one whose header module has not resolved yet,
 * leaves the banner in normal flow (EPS-4439 AC2).
 */
@Injectable({ providedIn: 'root' })
export class StickyHeaderService {
  private readonly sticky = signal(false);

  /** Whether a header on this page has declared that it pins. */
  readonly isSticky = this.sticky.asReadonly();

  setSticky(isSticky: boolean): void {
    this.sticky.set(isSticky);
  }
}
